import { StrapiImage } from '@/types/strapi-image'

/**
 *
 * @param img
 */
export const getStrapiImage = (img?: StrapiImage) => {
  if (!img?.data) {
    return { src: '' }
  }

  return {
    src:
      (import.meta.env.VITE_ENV === 'local' ? import.meta.env.VITE_PUBLIC_STRAPI_ENDPOINT : '') +
      img.data.attributes.url,
    mime: img.data.attributes.mime,
    width: img.data.attributes.width,
    height: img.data.attributes.height,
  }
}
